import http from './http-common'

export type GiftRequest = {
    email: string
    plan: number
    // Demanda de backend: classificar o brinde por origem (Congresso/Parceria/...).
    // Enviado apenas quando preenchido; o backend ignora se ainda não suportar.
    tag?: string
}

export type GiftFilter = {
    page: number,
    size: number,
    search?: string,
    status?: 'used' | 'unused'
}

export const createGifts = (gift: GiftRequest[]) => http.post('/gift', gift)

export const getGiftsPaginated = (filter: GiftFilter) => {
    let request = `/gift?`
    if (filter.search !== undefined) request = request + `search=${encodeURIComponent(filter.search)}&`
    if (filter.status) request = request + `status=${filter.status}&`
    request = request + `size=${filter.size}&page=${filter.page}`
    return http.get(request)
}

export const getEmailAndNotUsed = () => http.get(`/gift/check`)

export const ActivateGift = () => http.post(`/gift/activate`)

